import { render, staticRenderFns } from "./BoxSelect.vue?vue&type=template&id=28c35171"
import script from "./BoxSelect.vue?vue&type=script&lang=js"
export * from "./BoxSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports